
import { useCallback, useState, useEffect } from "react";




export const useCheckData = (datos) => {
    const [selected, setSelected] = useState([]);

    const handleSelectAllClick = useCallback((event) => {
        if (event.target.checked) {
            const newSelected = datos.map((p) => p.id || p._id);
            setSelected(newSelected);
        } else {
            setSelected([]);
        }
    }, [datos]);
    


    const handleClick = useCallback((id) => {
        setSelected((items) => {
            const newSelected = items.includes(id) 
            ? items.filter((item) => item !== id) 
            : [...items, id];
            return newSelected;
        });
    }, []);


    const isSelected = useCallback( (id) => selected.includes(id), [selected]);
    

    return {
        selected,
        setSelected,
        handleSelectAllClick,
        handleClick,
        isSelected,
    }

}





export const useProductosOC = (data) => {
    
    const [selected, setSelected] = useState([]);
    const [itemsFinal, setItemsFinal] = useState([]);

    
    useEffect(() => {
        if (!data) return;

        const itemsAgrupados = data.reduce((acc, item) => {
                const prodId = item.producto._id;
                if (!acc[prodId]) {
                    acc[prodId] = {
                        _id: prodId, 
                        producto: item.producto.nombre,
                        totalCantidad: 0,
                        detalle: [],
                        precio: "",
                        total: 0,
                    };
                }
                acc[prodId].totalCantidad += item.cantidad;
                acc[prodId].detalle.push({
                granja: item.granja,
                cantidad: item.cantidad
            });
            return acc;
        }, {});

        setItemsFinal(Object.values(itemsAgrupados));
    }, [data]);



    const handleClick = (item) => {
        setSelected((prev) => {
        const exists = prev.find((p) => p._id === item._id);
        if (exists) {
            return prev.filter((p) => p._id !== item._id);
        } else {
            return [...prev, { ...item }];
        }
        });
    };



    const handleSelectAllClick = (items) => {
        if (selected.length === items.length) {
            setSelected([]);
        } else {
            setSelected(items.map((item) => ({ ...item })));
        }
    };



    const handlePrecioChange = (id, precio) => {
        const precioNumber = Number(precio) || 0;
        setSelected((prev) =>
            prev.map((p) =>
            p._id === id
                ? { ...p, precio: precioNumber, total: precioNumber * (p.totalCantidad || 0)}
                : p
            )
        );

        setItemsFinal((prev) =>
            prev.map((p) =>
            p._id === id
                ? { ...p, precio: precioNumber, total: precioNumber * (p.totalCantidad || 0)}
                : p
            )
        );
    };


    const isSelected = (id) => selected.some((p) => p._id === id);


    return {
        selected,
        handleClick,
        handleSelectAllClick,
        handlePrecioChange,
        isSelected,
        itemsFinal,
        setItemsFinal
    };


}




